import { Component } from "react"

/* Modal */
import Modal from "react-modal"

/* DatePicker */
import DatePicker, { registerLocale } from "react-datepicker"
import ruLocale from "date-fns/locale/ru"
import enLocale from "date-fns/locale/en-US"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../translates/translate"

/* DatePicker Settings */
registerLocale("ru", ruLocale)
registerLocale("en", enLocale)



class DateFilter extends Component {

    render = () => {

        /* Fields */
        const { filter, start, end, selected, setSelected, close, apply, setDate, DATES, language } = this.props

        const dateLocale = language === "en" ? "en" : "ru"

        return (
            <Modal
                isOpen={filter}
                onRequestClose={() => close()}
                className={`dashboard-filter-modal ${selected === "period" ? "period" : ""}`}
                overlayClassName="dashboard-filter-overlay"
                closeTimeoutMS={200}
            >

                <div className="dashboard-filter-header">
                    <h2>{t("filter.selectDate")}</h2>
                    <div onClick={() => close()} className="dashboard-filter-close">
                        <img src="/images/close.png" alt="Close" />
                    </div>
                </div>

                <div className="dashboard-filter-container">

                    <div className="dashboard-filter-container-inner">

                        {/* Dates */}
                        <div className="dashboard-filter-dates">
                            {DATES.map((item, index) =>
                                <div onClick={() => setSelected(item.key)} className={`dashboard-filter-date ${item.key === selected ? "active" : "default"}`} key={`${index}`}>{item.text}</div>
                            )}
                        </div>

                        {/* Period */}
                        {selected === "period" &&
                            <div className="dashboard-filter-period-container">

                                <div className="dashboard-filter-period-title">{t("filter.selectDates")}</div>

                                <div className="dashboard-filter-period">

                                    <DatePicker
                                        selected={start}
                                        onChange={(date) => setDate(date, "start")}
                                        selectsStart
                                        startDate={start}
                                        endDate={end}
                                        dateFormat="dd-MM-yyyy"
                                        locale={dateLocale}
                                    />

                                    <span>-</span>

                                    <DatePicker
                                        selected={end}
                                        onChange={(date) => setDate(date, "end")}
                                        selectsEnd
                                        startDate={start}
                                        endDate={end}
                                        minDate={start}
                                        dateFormat="dd-MM-yyyy"
                                        locale={dateLocale}
                                    />
                                </div>
                            </div>
                        }

                    </div>

                    {/* Bottom */}
                    <div className="dashboard-filter-bottom">
                        <div onClick={() => close()} className="dashboard-filter-button cancel">{t("filter.cancel")}</div>
                        <div onClick={() => apply()} className="dashboard-filter-button">{t("filter.apply")}</div>
                    </div>

                </div>

            </Modal>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        language: state.language,
    }
}

export default connect(mapStateToProps)(DateFilter)
